import { PopoverButton } from '@headlessui/react';
import { Link } from '@/i18n/routing';
import { useLocale } from 'next-intl';
import { useSuspenseQuery } from '@apollo/client';
import { useTranslations } from 'next-intl';
import { HeaderMenuPlacementEnum } from '@/__generated__/graphql';
import { SearchLocationGroupsQuery, DESTINATIONS_PLACEMENT } from '@/query';

import { navigation } from './constants';
import { PopoverMenu } from './PopoverMenu';

export const DefaultNavigation = ({ menuItems = [] }) => {
  const locale = useLocale();
  const t = useTranslations();
  const { data } = useSuspenseQuery(SearchLocationGroupsQuery, {
    variables: {
      filter: { purpose: DESTINATIONS_PLACEMENT },
      locale,
    },
    errorPolicy: 'ignore',
  });

  const destinations = data?.listingGroups?.collection || [];

  const popoverButtonClassName =
    'flex w-full items-center rounded-10 text-slate-800 text-base font-medium py-[6px] !px-3 hover:bg-slate-100 hover:text-slate-800';

  return (
    <menu
      key={locale}
      className="hidden lg:flex gap-x-2 min-[1120px]:gap-x-[34px] ml-3 min-[1120px]:ml-6 xl:ml-[68px]"
    >
      {navigation.map((menuItem, i) =>
        !menuItem.links && !menuItem.destination ? (
          <Link
            key={i}
            href={menuItem.href}
            prefetch={false}
            target={menuItem.target}
            className="inline-flex items-center text-base text-slate-500 hover:text-slate-700 focus:#197775 outline-none"
          >
            {t(menuItem.name)}
          </Link>
        ) : (
          <PopoverMenu
            menuItem={menuItem}
            destinations={destinations.length}
            key={i}
          >
            {({ close }) => (
              <div className="shrink rounded-20 bg-white p-6 shadow">
                {menuItem.destination
                  ? destinations.map((group) => (
                      <PopoverButton
                        as={Link}
                        key={group.slug}
                        href={`/destinations/${group.slug}`}
                        prefetch={false}
                        onClick={close}
                        className={popoverButtonClassName}
                      >
                        {group.menuTitle || group.name}
                      </PopoverButton>
                    ))
                  : null}
                {menuItem.links.map((item) => (
                  <PopoverButton
                    as={Link}
                    key={item.name}
                    href={item.href}
                    prefetch={false}
                    onClick={close}
                    className={popoverButtonClassName}
                  >
                    {t(item.name)}
                  </PopoverButton>
                ))}
                {!menuItem.destination
                  ? menuItems
                      .filter(
                        (item) =>
                          item.headerMenuPlacement ===
                          HeaderMenuPlacementEnum.Resources
                      )
                      .map((item) => (
                        <PopoverButton
                          as={Link}
                          key={item.title}
                          href={`/blogs/${item.blogSlug}/${item.postSlug}`}
                          prefetch={false}
                          onClick={close}
                          className={popoverButtonClassName}
                        >
                          {t(item.title)}
                        </PopoverButton>
                      ))
                  : null}
              </div>
            )}
          </PopoverMenu>
        )
      )}
    </menu>
  );
};
